import type {
  LawnSpaceCta,
  LawnSpaceFailureReason,
  LawnSpaceOutcome,
  LawnSpaceRank,
} from './types'

export const LAWN_SPACE_SCORE = {
  crabgrassScout: 80,
  dandelionBurst: 140,
  drySoilMeteor: 180,
  thatchBelt: 1800,
  waveClear: 500,
  noHitWave: 1000,
  powerupPickup: 50,
  perfectLawn: 5000,
} as const

const CTA_BY_REASON: Record<string, LawnSpaceCta> = {
  weed: {
    href: '/tools/herbicide-timing',
    label: 'Time Your Weed Control',
    description: 'Turn that weed pressure into a clean herbicide timing plan.',
    target: 'herbicide',
  },
  dry_soil: {
    href: '/tools/watering-schedule',
    label: 'Fix Your Watering Schedule',
    description: 'Dial in watering before dry soil starts stressing the lawn.',
    target: 'watering',
  },
  pickups: {
    href: '/tools/fertilizer-calculator',
    label: 'Plan Your Fertilizer Rate',
    description: 'You chased the good stuff. Now calculate what your lawn actually needs.',
    target: 'fertilizer',
  },
  perfect: {
    href: '/lawn-products-guide',
    label: 'See the Product Guide',
    description: 'Keep the streak going with the 2026 lawn product picks.',
    target: 'products_guide',
  },
  fallback: {
    href: '/#analysis-card',
    label: 'Analyze Your Lawn',
    description: 'Get a real care plan from a photo of your grass.',
    target: 'analysis',
  },
}

export function getLawnSpaceRank(score: number): LawnSpaceRank {
  if (score >= 15000) return 'Certified Lawn Legend'
  if (score >= 8000) return 'Lush'
  if (score >= 3000) return 'Recovering'
  return 'Patchy'
}

export function formatLawnSpaceScore(score: number): string {
  return Math.max(0, Math.round(score)).toLocaleString('en-US')
}

export function getLawnSpaceCta(input: {
  outcome: LawnSpaceOutcome
  failureReason?: LawnSpaceFailureReason
  score: number
  powerupsCollected: number
}): LawnSpaceCta {
  if (input.outcome === 'perfect_lawn') return CTA_BY_REASON.perfect
  if (input.failureReason === 'weed' || input.failureReason === 'boss') {
    return CTA_BY_REASON.weed
  }
  if (input.failureReason === 'dry_soil') return CTA_BY_REASON.dry_soil
  if (input.score < 5000 && input.powerupsCollected >= 3) return CTA_BY_REASON.pickups
  return CTA_BY_REASON.fallback
}

